export default (number, locale) => {
    const data = {
        nl: {
            1: 'Een',
            2: 'Twee',
            3: 'Drie',
            4: 'Vier',
            5: 'Vijf',
            6: 'Zes',
            7: 'Zeven',
            8: 'Acht',
            9: 'Negen',
            10: 'Tien',
            11: 'Elf',
            12: 'Twaalf',
        },
        'en-150': {
            1: 'One',
            2: 'Two',
            3: 'Three',
            4: 'Four',
            5: 'Five',
            6: 'Six',
            7: 'Seven',
            8: 'Eight',
            9: 'Nine',
            10: 'Ten',
            11: 'Eleven',
            12: 'Twelve',
        },
    };

    if (!window.appLocale) {
        return data.en[number];
    }

    return data[window.appLocale][number];
};
